import { render, staticRenderFns } from "./SensorsAdd.vue?vue&type=template&id=db7c4d6c&scoped=true"
import script from "./SensorsAdd.vue?vue&type=script&lang=js"
export * from "./SensorsAdd.vue?vue&type=script&lang=js"
import style0 from "./SensorsAdd.vue?vue&type=style&index=0&id=db7c4d6c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db7c4d6c",
  null
  
)

export default component.exports